import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IApiContact } from 'src/app/shared/modules/graphql/types/types';
import { Columns, IInvestigationTableConfig, TableType } from '../../investigations-table-view/investigations-table-new/investigations-table-new.component';
import {
  contactsProfileCompanyInformationView,
  contactsProfileContactInformationViewAssigned,
  contactsInvestigations,
  contactsInvestigationsView,
} from "src/app/shared/helpers/auth-config/contacts.config";
import { ContactService } from 'src/app/shared/services';

@Component({
  templateUrl: './contact-management.component.html',
  styleUrls: ['./contact-management.component.scss']
})
export class ContactManagementComponent implements OnInit {
  public permissionConfig = {
    contactsProfileCompanyInformationView,
    contactsProfileContactInformationViewAssigned,
    contactsInvestigations,
    contactsInvestigationsView
  };

  public contactConfig: IInvestigationTableConfig = {
    type: TableType.contact,
    displayedColumns: [Columns.createdAt, Columns.nefcoNumber, Columns.contactRole, Columns.priority, Columns.lossDate, Columns.riskType,
    Columns.investigationLocation, Columns.status],
    contactId: ""
  };

  public contact: IApiContact;
  public selectedTab = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contactService: ContactService
  ) { }

  public ngOnInit() {
    this.contact = this.route.snapshot.data.contact;
    this.contactConfig.contactId = this.contact.id;
  }

  public load() {
    this.contactService.getById(this.contact.id).toPromise().then((contact) => this.contact = contact);
  }

  public goBack() {
    this.router.navigate(["admin", "contacts", "list"]);
  }

}
